export const GET_FILE_URL="GET_FILE_URL"
export const IS_LOADING_FILE="IS_LOADING_FILE"